import { call, put, takeEvery } from 'redux-saga/effects';

import {
  RESEND_OTP,
  resendOtpBegin,
  resendOtpFailure,
  resendOtpSuccess,
  VERIFY_OTP,
  verifyOtpBegin,
  verifyOtpFailure,
  verifyOtpSuccess,
} from './actions';
import { OTP_INVALID_REQUEST } from './constants';
import { resendOtpRequest, verifyOtpRequest } from './service';

export function* handleVerifyOtp(action) {
  try {
    yield put(verifyOtpBegin());
    const { sessionId, otpCode, next } = action.payload;
    const { success, redirectUrl, passwordExpiryNudge } = yield call(verifyOtpRequest, sessionId, otpCode, next);
    if (!success) {
      // The backend returns its specific failure codes (otp-expired, otp-attempts-exceeded,
      // otp-session-not-found, …) as 400s, handled in the catch below. A 200 with success:false
      // is an unexpected/defensive case, so fall back to the generic code instead of asserting
      // "incorrect code".
      yield put(verifyOtpFailure(OTP_INVALID_REQUEST));
      return;
    }
    yield put(verifyOtpSuccess(redirectUrl, passwordExpiryNudge));
  } catch (e) {
    const errorCode = e.response?.data?.error_code || OTP_INVALID_REQUEST;
    yield put(verifyOtpFailure(errorCode));
  }
}

export function* handleResendOtp(action) {
  try {
    yield put(resendOtpBegin());
    const { sessionId } = action.payload;
    const { resendCooldownSeconds } = yield call(resendOtpRequest, sessionId);
    // Store an absolute deadline (not just the duration) so the reducer's value changes
    // on every successful resend, even if the backend returns the same duration twice in
    // a row - that's what makes the page's re-arm effect fire again on a second resend.
    const resendCooldownDeadline = resendCooldownSeconds > 0 ? Date.now() + resendCooldownSeconds * 1000 : 0;
    yield put(resendOtpSuccess(resendCooldownDeadline));
  } catch (e) {
    const errorCode = e.response?.data?.error_code || OTP_INVALID_REQUEST;
    yield put(resendOtpFailure(errorCode));
  }
}

export default function* saga() {
  yield takeEvery(VERIFY_OTP.BASE, handleVerifyOtp);
  yield takeEvery(RESEND_OTP.BASE, handleResendOtp);
}
